import { v4 as uuid } from "uuid";

import { toPng } from "./render";

export type Pixels = Record<number, boolean>;

export class Drawing {
  static side = 32;

  readonly id: string;
  readonly pixels: Pixels;
  readonly preview: string;
  readonly strokes: number[][];
  readonly currStroke: number;

  get canUndo(): boolean {
    return this.currStroke >= 0;
  }

  get canRedo(): boolean {
    return this.currStroke < this.strokes.length - 1;
  }

  constructor(options?: {
    id?: string;
    pixels?: Pixels;
    preview?: string;
    strokes?: number[][];
    currStroke?: number;
  }) {
    this.id = options?.id ?? uuid();
    this.pixels = options?.pixels ?? {};
    this.preview = options?.preview ?? toPng(this);
    this.strokes = options?.strokes ?? [];
    this.currStroke =
      options?.currStroke ??
      (options?.strokes ? options.strokes.length - 1 : -1);
  }

  static from(drawing: Drawing): Drawing {
    return new Drawing({
      id: uuid(),
      pixels: Object.assign({}, drawing.pixels),
      preview: drawing.preview,
      strokes: [...drawing.strokes.map((stroke) => [...stroke])],
      currStroke: drawing.currStroke,
    });
  }
}
